<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <router-view></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>
<style>
  .app-main {
    /*margin-top: 50px;*/
    padding-top: 50px;
    position: absolute;
    width: 100%;
    top: 0px;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue